






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Sistema} from '@/model/resource/Sistema'
import {InputSistemaSchema} from '@/schema/resource/Sistema/InputSistemaSchema'

@Component
export default class PersistSistemaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputSistemaSchema()
  sistema = new Sistema()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.sistema.getSistema(id)
    }

    $.await.done('getSistema')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.sistema.persistSistema()
    await Helper.successAndPush('system.success.persist', '/sistema/list')
  }
}
